import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  paper: {
    padding: '1%',
  },
  container: {
    padding: '1%',
    marginBottom: '500px',
  },
  large: {
    width: '2%',
    height: '1%',
  },
  vacio: {
    textAlign: 'center',
    paddingTop: 50,
    paddingBottom: 50,
    paddingRight: 10,
    paddingLeft: 10,
    background: '#e8e8e8',
  },
  full: {
    width: '100%',
  },
  button: {
    color: '#ffffff',
  },
  typo: {
    padding: '20px 0px 20px 0px',
    fontWeight: '400',
    fontSize: 'x-large',
  },
  typoSaludo: {
    paddingBottom: '20px',
    fontWeight: '400',
  },
  typoTitle: {
    paddingBottom: '20px',
    fontWeight: '00',
    fontSize: 'xxx-large',
  },
  fxl: {
    fontSize: 'x-large',
  },
  fxxl: {
    fontSize: 'xx-large',
  },
}));
